import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=7e9cb062&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=7e9cb062&prod&scoped=true&lang=css"
import style1 from "./detail.vue?vue&type=style&index=1&id=7e9cb062&prod&lang=scss&scoped=true"
import style2 from "@/styles/pc.css?vue&type=style&index=2&id=7e9cb062&prod&scoped=true&lang=css&external"
import style3 from "./detail.vue?vue&type=style&index=3&id=7e9cb062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9cb062",
  null
  
)

export default component.exports